import ufeApi from 'services/api/ufeApi';
import RCPSCookies from 'utils/RCPSCookies';
import authUtils from 'utils/Authentication';

const SDN_URL_V2 = '/gway/v1/dotcom/auth/v2/emailVerificationStoreBI';

async function emailVerificationStoreBI(email, token) {
    const headers = {
        'Content-type': 'application/json',
        'x-requested-source': 'web'
    };
    const payload = {};

    if (email) {
        payload.email = email;
    } else if (token) {
        payload.token = token;
    }

    if (RCPSCookies.isRCPSAuthEnabled()) {
        headers.deviceId = await authUtils.getFingerPrint();
    }

    return ufeApi
        .makeRequest(SDN_URL_V2, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers
        })
        .then(data => {
            return data.errorCode || data.errors ? Promise.reject(data) : data;
        })
        .catch(err => Promise.reject(err));
}

export default { emailVerificationStoreBI };
